import React from 'react';
import { AircraftResponse } from './FleetManagmentClient.ts';
import { FleetManagementState } from './FleetManagementState.ts';
import { useSubscription } from '@autopylot-internal/state';
import { useInstance } from '../support/ioc/useInstance';
import { formatDuration } from '../support/helpers/format.ts';
import { CalendarIcon, IIconComponent, PlaneIcon, TimeIcon } from '../components/icons/Icons.tsx';
import { IonText } from '@ionic/react';
import { ITriggerPaywallSource, PaywallDialogViewModel } from '../paywall/PaywallDialogViewModel.tsx';
import { RevenueCatModel } from '../paywall/revenue-cat/RevenueCatModel.ts';

const AircraftStat: React.FC<{label: string, Icon: IIconComponent, value: string | number}> = ({ label, Icon, value }) => (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <IonText color="medium" style={{fontSize: 12, fontWeight: 'bold'}}>{label}</IonText>
        <div style={{display: 'flex', alignItems: 'center', gap: 5, fontSize: 20}}><Icon color="dark" /><IonText color="dark">{value}</IonText></div>
    </div>
);

export const AircraftStats: React.FC<{ aircraft: AircraftResponse, paywallTrigger: ITriggerPaywallSource }> = ({ aircraft, paywallTrigger }) => {
    const state = useInstance(FleetManagementState);
    useSubscription(() => state);

    const revenueCat = useInstance(RevenueCatModel);
    useSubscription(() => revenueCat);

    const paywall = useInstance(PaywallDialogViewModel);

    const plannedMissions = state.getPlannedMissions(aircraft);
    const completedMissions = state.getCompletedMissions(aircraft);
    const completedFlightMinutes = completedMissions.reduce((minutes, mission) => minutes + mission.getDurationMinutes(), 0);

    const onClickNudge = async (e: any) => {
        e.stopPropagation();
        await paywall.requirePurchase({ triggerSource: paywallTrigger });
    };

    if (!revenueCat.hasUpgraded()) {
        return (
            <>
                <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', fontSize: 12, fontWeight: 'bold', color: 'var(--ion-color-medium)'}}>
                    <div>Upcoming</div><div>Flown</div><div>Est. Airtime</div>
                </div>

                {/* 102% because this message doesn't quite fit on iphone 12 */}
                <div style={{width: '102%', fontSize: 15, textAlign: 'center', padding: '5px 0 10px', cursor: 'pointer'}} onClick={onClickNudge}>
                    <IonText color="medium">Unlock drone stats & defaults with </IonText>&nbsp;<IonText color="primary"><b>AutoPylot+</b></IonText>
                </div>
            </>
        );
    }

    return (
        <div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
            <AircraftStat label="Upcoming" value={plannedMissions.length} Icon={CalendarIcon} />
            <AircraftStat label="Flown" value={completedMissions.length} Icon={PlaneIcon} />
            <AircraftStat label="Est. Airtime" value={formatDuration(completedFlightMinutes) || '0 h'} Icon={TimeIcon} />
        </div>
    );

};
